import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    // Header
    analyzers: "Analyzers",
    allAnalyzers: "All Analyzers",
    viewAllAnalyzers: "View all available analyzers",
    transcribe: "Transcribe",
    dashboard: "Dashboard",
    help: "Help",
    analytics: "Analytics",
    admin: "Admin",
    logout: "Logout",
    signIn: "Sign In",
    getStarted: "Get Started",

    // Analyzer Landing
    industryAnalyzers: "Industry-Specific Call Analyzers",
    selectIndustry: "Select your industry for specialized AI analysis tailored to your business needs",
    industriesCovered: "Industries Covered",
    callsAnalyzed: "Calls Analyzed",
    avgImprovement: "Avg Score Improvement",
    activeUsers: "Active Users",
    callTypes: "Call Types",
    industries: "Industries",
    launchAnalyzer: "Launch Analyzer",
    comingSoon: "Coming Soon",
    needCustom: "Need a Custom Analyzer for Your Industry?",
    customDescription: "Professional and Enterprise plans can request custom analysis templates tailored to your specific business needs",
    viewPlans: "View Plans",
    industryAIModels: "Industry-Specific AI Models",
    aiModelsDescription: "Each analyzer uses specialized AI training for your industry's unique requirements, terminology, and best practices. Select the analyzer that matches your business for the most accurate results.",

    // Home Improvement Analyzer
    homeImprovement: "Home Improvement",
    homeImprovementDesc: "Analyze calls for construction, renovation, and home services",
    uploadAudio: "Upload Audio File",
    dragDrop: "Drag and drop your audio file here, or click to browse",
    supportedFormats: "Supported formats: MP3, WAV, M4A, WEBM (max 25MB)",
    agentName: "Agent Name",
    enterAgentName: "Enter agent name",
    callType: "Call Type",
    selectCallType: "Select call type",
    coldCall: "Cold Call",
    warmLead: "Warm Lead",
    rehash: "Rehash",
    confirmation: "Confirmation",
    followUp: "Follow-up",
    analyzeCall: "Analyze Call",
    analyzing: "Analyzing...",
    processing: "Processing your call...",

    // Results
    analysisResults: "Analysis Results",
    overallScore: "Overall Score",
    transcript: "Transcript",
    analysis: "Analysis",
    downloadPDF: "Download PDF Report",
    newAnalysis: "New Analysis",

    // Login
    welcomeBack: "Welcome Back",
    loginSubtitle: "Sign in to access your call analysis dashboard",
    email: "Email",
    password: "Password",
    rememberMe: "Remember me",
    forgotPassword: "Forgot password?",
    noAccount: "Don't have an account?",
    register: "Register",

    // Register
    createAccount: "Create Account",
    registerSubtitle: "Start analyzing your calls with AI-powered insights",
    fullName: "Full Name",
    confirmPassword: "Confirm Password",
    agreeTerms: "I agree to the",
    termsOfService: "Terms of Service",
    and: "and",
    privacyPolicy: "Privacy Policy",
    haveAccount: "Already have an account?",

    // Dashboard
    myDashboard: "My Dashboard",
    recentAnalyses: "Recent Analyses",
    viewAll: "View All",
    noAnalyses: "No analyses yet. Upload your first call to get started!",

    // Errors
    error: "Error",
    uploadError: "Failed to upload file",
    analysisError: "Failed to analyze call",
    loginError: "Invalid email or password",

    // Language
    language: "Language",
    english: "English",
    spanish: "Spanish"
  },
  es: {
    // Header
    analyzers: "Analizadores",
    allAnalyzers: "Todos los Analizadores",
    viewAllAnalyzers: "Ver todos los analizadores disponibles",
    transcribe: "Transcribir",
    dashboard: "Panel",
    help: "Ayuda",
    analytics: "Estadisticas",
    admin: "Admin",
    logout: "Cerrar Sesion",
    signIn: "Iniciar Sesion",
    getStarted: "Comenzar",

    // Analyzer Landing
    industryAnalyzers: "Analizadores de Llamadas por Industria",
    selectIndustry: "Selecciona tu industria para un analisis de IA especializado adaptado a las necesidades de tu negocio",
    industriesCovered: "Industrias Cubiertas",
    callsAnalyzed: "Llamadas Analizadas",
    avgImprovement: "Mejora Promedio",
    activeUsers: "Usuarios Activos",
    callTypes: "Tipos de Llamadas",
    industries: "Industrias",
    launchAnalyzer: "Iniciar Analizador",
    comingSoon: "Proximamente",
    needCustom: "Necesitas un Analizador Personalizado para tu Industria?",
    customDescription: "Los planes Profesional y Empresarial pueden solicitar plantillas de analisis personalizadas adaptadas a las necesidades especificas de tu negocio",
    viewPlans: "Ver Planes",
    industryAIModels: "Modelos de IA Especificos por Industria",
    aiModelsDescription: "Cada analizador utiliza entrenamiento de IA especializado para los requisitos unicos, terminologia y mejores practicas de tu industria. Selecciona el analizador que coincida con tu negocio para obtener los resultados mas precisos.",

    // Home Improvement Analyzer
    homeImprovement: "Mejoras del Hogar",
    homeImprovementDesc: "Analiza llamadas de construccion, renovacion y servicios del hogar",
    uploadAudio: "Subir Archivo de Audio",
    dragDrop: "Arrastra y suelta tu archivo de audio aqui, o haz clic para buscar",
    supportedFormats: "Formatos soportados: MP3, WAV, M4A, WEBM (max 25MB)",
    agentName: "Nombre del Agente",
    enterAgentName: "Ingresa el nombre del agente",
    callType: "Tipo de Llamada",
    selectCallType: "Selecciona el tipo de llamada",
    coldCall: "Llamada en Frio",
    warmLead: "Prospecto Caliente",
    rehash: "Seguimiento",
    confirmation: "Confirmacion",
    followUp: "Seguimiento",
    analyzeCall: "Analizar Llamada",
    analyzing: "Analizando...",
    processing: "Procesando tu llamada...",

    // Results
    analysisResults: "Resultados del Analisis",
    overallScore: "Puntuacion General",
    transcript: "Transcripcion",
    analysis: "Analisis",
    downloadPDF: "Descargar Reporte PDF",
    newAnalysis: "Nuevo Analisis",

    // Login
    welcomeBack: "Bienvenido de Nuevo",
    loginSubtitle: "Inicia sesion para acceder a tu panel de analisis de llamadas",
    email: "Correo Electronico",
    password: "Contrasena",
    rememberMe: "Recordarme",
    forgotPassword: "Olvidaste tu contrasena?",
    noAccount: "No tienes una cuenta?",
    register: "Registrarse",

    // Register
    createAccount: "Crear Cuenta",
    registerSubtitle: "Comienza a analizar tus llamadas con informacion impulsada por IA",
    fullName: "Nombre Completo",
    confirmPassword: "Confirmar Contrasena",
    agreeTerms: "Acepto los",
    termsOfService: "Terminos de Servicio",
    and: "y",
    privacyPolicy: "Politica de Privacidad",
    haveAccount: "Ya tienes una cuenta?",

    // Dashboard
    myDashboard: "Mi Panel",
    recentAnalyses: "Analisis Recientes",
    viewAll: "Ver Todo",
    noAnalyses: "Aun no hay analisis. Sube tu primera llamada para comenzar!",

    // Errors
    error: "Error",
    uploadError: "Error al subir el archivo",
    analysisError: "Error al analizar la llamada",
    loginError: "Correo o contrasena invalidos",

    // Language
    language: "Idioma",
    english: "Ingles",
    spanish: "Espanol"
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'en';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || translations['en'][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'es' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
